// Unpublished Work © 2023 Deere & Company.

import {enqueueToaster} from '@deere/isg.component-library';
import {useCallback} from 'react';
import {logUiErrors} from '../../App/utils/log-ui-errors';
import {ToastType} from '../models/toast';

export function showToast(toast: ToastType) {
    if (toast.variant === 'error') {
        logUiErrors(
            `Toast message : ${toast.message}`,
            'Work Planner Toast Error',
            0,
            0,
            toast.occurredError,
        );
    }
    enqueueToaster(toast.message, toast.title, {
        variant: toast.variant,
        isCloseable: true,
    });
}

export function useToast() {
    return useCallback((toast: ToastType) => {
        showToast(toast);
    }, []);
}
